// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2Lnzj","errors":"Errors_errors__1I3BN"};